import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL, { Providers } from "../../services/Config";

export const fetchUser = createAsyncThunk("user/fetchMember", async () => {
    const token = localStorage.getItem('authToken');
    const response = await axios.get(`${API_BASE_URL()}/v3/${Providers()}/provider-operators?order_by=-created`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    });
    return response.data;
});

const userSlice = createSlice({
    name: "user",
    initialState: {
        memberList: [],
        userList: [],
        loading: false,
        error: null
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUser.fulfilled, (state, action) => {
                state.loading = false;
                state.memberList = action.payload;
            })
            .addCase(fetchUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})

export default userSlice.reducer;
